/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popSubTask.vue?vue&type=template&id=d90527da&scoped=true"
import script from "./popSubTask.vue?vue&type=script&lang=js"
export * from "./popSubTask.vue?vue&type=script&lang=js"
import style0 from "./popSubTask.vue?vue&type=style&index=0&id=d90527da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90527da",
  null
  
)

export default component.exports